<template>
    <div class="listTable">
        <div class="margins">
            <span>
                <el-button class="base-button" size="mini" type="primary" @click="handleFilter">刷新</el-button>
            </span>
            <span>
            </span>
        </div>
        <YzTable :columnApi="columns" :afterRequest="afterRequest" :listApi="listArray" :searchForm="searchForm"
            :autoLoad="true" ref="YzTable" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchForm: {},
            listArray: "/wxrw/queryUseList",
            columns: "json/usageRecord.json?v=2",
        };
    },

    mounted() {

    },

    methods: {
        handleFilter() {
            this.searchForm.page = 1;
            this.$refs["YzTable"].getList(this.searchForm, true);
        },
        afterRequest(res) {
            return {
                result: {
                    items: res.result,
                    total: 0
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>